module.exports = kolibriGlobal.coreVue.router;